import { Component } from '@theme/component';

class ProductDetailAccordionsComponent extends Component {
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#abortController;
    const section = this.closest('.shopify-section, dialog');

    for (const details of this.querySelectorAll('details[data-accordion-item]')) {
      details.addEventListener('toggle', this.#handleToggle, { signal });
    }
    section?.addEventListener('click', this.#handleBenefitClick, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }

  /**
   * @param {string} target
   * @param {boolean} [shouldScroll]
   */
  openTarget(target, shouldScroll = true) {
    const details = this.querySelector(`details[data-target="${target}"]`);
    if (!(details instanceof HTMLDetailsElement)) return;

    if (!details.open) {
      details.open = true;
    }

    this.#closeOthers(details);

    if (shouldScroll) {
      this.#scrollSummaryIntoView(details);
    }
  }

  /**
   * @param {Event} event
   */
  #handleToggle = (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.hasAttribute('data-accordion-item')) return;

    if (details.open) {
      this.#closeOthers(details);
      this.#scrollSummaryIntoView(details);
    }
  };

  /**
   * @param {MouseEvent} event
   */
  #handleBenefitClick = (event) => {
    if (!(event.target instanceof HTMLElement)) return;

    const trigger = event.target.closest('[data-accordion-target]');
    if (!(trigger instanceof HTMLElement)) return;

    const currentSection = this.closest('.shopify-section, dialog');
    if (currentSection && trigger.closest('.shopify-section, dialog') !== currentSection) return;

    const target = trigger.dataset.accordionTarget;
    if (!target) return;

    event.preventDefault();
    this.openTarget(target, true);
  };

  /**
   * @param {HTMLDetailsElement} activeDetails
   */
  #closeOthers(activeDetails) {
    for (const details of this.querySelectorAll('details[data-accordion-item]')) {
      if (details instanceof HTMLDetailsElement && details !== activeDetails) {
        details.open = false;
      }
    }
  }

  /**
   * @param {HTMLDetailsElement} details
   */
  #scrollSummaryIntoView(details) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const summary = details.querySelector('summary');
    if (!(summary instanceof HTMLElement)) return;

    window.requestAnimationFrame(() => {
      summary.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    });
  }
}

if (!customElements.get('product-detail-accordions-component')) {
  customElements.define('product-detail-accordions-component', ProductDetailAccordionsComponent);
}
